import { render, staticRenderFns } from "./AiHome.vue?vue&type=template&id=23b82a3b&scoped=true&"
import script from "./AiHome.vue?vue&type=script&lang=js&"
export * from "./AiHome.vue?vue&type=script&lang=js&"
import style0 from "./AiHome.vue?vue&type=style&index=0&id=23b82a3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b82a3b",
  null
  
)

export default component.exports